var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaseManagementFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24122 17.5513H3.06891C1.92628 17.5513 0.999993 16.625 1 15.4824L1.00008 3.06891C1.00009 1.92628 1.92637 1 3.069 1H12.3794C13.522 1 14.4483 1.92629 14.4483 3.06892V7.20676M14.9655 14.9652L16 15.9997M15.4828 12.8963C15.4828 14.3246 14.3249 15.4824 12.8966 15.4824C11.4683 15.4824 10.3105 14.3246 10.3105 12.8963C10.3105 11.468 11.4683 10.3101 12.8966 10.3101C14.3249 10.3101 15.4828 11.468 15.4828 12.8963Z",
    stroke: "#E94D51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseManagementFilled);
export default __webpack_public_path__ + "static/media/case-management-filled.c3014e8c6bd27f7efbfee35e54ae58a5.svg";
export { ForwardRef as ReactComponent };